import { useContext, useMemo } from 'react';
import ConfigContext from '@ubeya/shared-web/contexts/ConfigContext';
import privileges from './mocks/privileges.json';

export const PRIVILEGE_SLUGS_BY_ID = Object.fromEntries(privileges.data.map(({ id, slug }) => [id, slug]));

const usePrivileges = () => {
  const { t } = useContext(ConfigContext);
  const isLoading = false;
  const data = privileges;

  const privilegesOptions = useMemo(
    () => (data?.data || []).map(({ id, label, slug }) => ({ value: id, slug: t(slug), label: t(label) })),
    [data?.data, t]
  );

  const mappedPrivileges = useMemo(
    () => privilegesOptions.reduce((prev, option) => ({ ...prev, [option.value]: option.slug }), {}),
    [privilegesOptions]
  );

  return { isLoading, privilegesOptions, mappedPrivileges };
};

export default usePrivileges;
